export const multiChoice = "MultiChoice"
export const singleChoice = "SingleChoice"
